import React, { Component } from 'react';
import Layout from "../components/layout"


class Thankyou extends Component {
  



    render() {

      
        return (
          <div id="thankyou"><Layout>
                          <div className="row" style={{ padding: 20 + "px", backgroundColor: "#DCDCDC" }}>
                <div className="col">
                    <div className="card border-secondary mb-3 card-index" style={{ maxwidth: 100 + "%", minHeight: 30 + "rem" }}>

                        <div className="panel panel-primary"  style={{ paddingTop: 50 + "px", margin: "auto" }}>
                            <div className="panel-heading">
                             
                             
                            </div>
                            
                            <div className="inputdata"   style={{ marginLeft: 'auto', marginRight: 'auto', paddingBottom: 50 + "px" , textAlign:"center", fontSize: 18+"px"}} >The resource has been submitted successfully. Please click <a href="/view-resources">here</a> to see the Resource Lookup page </div>
                             </div>
                        <div className="card-body" style={{ paddingLeft: 30 + "px" }}>
                            
                       
                           
                        </div>
                     
                    </div>
                </div></div >
                </Layout>
                </div>
             

        );
    }
}

        




export default Thankyou;



